import { getLocalizedKeyword, searchFields } from 'utils/searchKeywords';

export const tokenize = value => value?.trim?.().match(/"[^"]*"|\S+/g) || [];

export const emptyFields = () => Object.fromEntries(searchFields.map(f => [f, '']));

export const buildSearchString = (fields, locale) =>
  searchFields
    .filter(f => fields[f]?.trim())
    .flatMap(f => {
      const keyword = getLocalizedKeyword(f, locale);
      return tokenize(fields[f]).map(token => `${keyword}:${token}`);
    })
    .join(' ');

export const buildSearchStringFromChips = (chips, locale) =>
  chips
    .filter(c => c?.value)
    .map(c => (c.field ? `${getLocalizedKeyword(c.field, locale)}:${c.value}` : c.value))
    .join(' ');

export const parseSearchString = (searchValue, locale) => {
  const fields = emptyFields();
  const pattern = /(\S+?):((?:"[^"]*")|\S*)/g;
  let match = pattern.exec(searchValue);
  while (match) {
    const [, , rawValue] = match;
    const value = rawValue.replace(/\*$/, '').replace(/^"=/, '"');
    searchFields.forEach(f => {
      const keyword = getLocalizedKeyword(f, locale);
      if (match[1].toLowerCase() === keyword.toLowerCase()) {
        fields[f] = fields[f] ? `${fields[f]} ${value}` : value;
      }
    });
    match = pattern.exec(searchValue);
  }
  return fields;
};

export const parseSearchStringToChips = (searchValue, locale) => {
  if (!searchValue) return [];
  const chips = [];
  // Walk the string token by token, preserving order and capturing plain-text tokens
  const pattern = /(\S+?):((?:"[^"]*")|\S+)|"[^"]*"|\S+/g;
  let match;
  while ((match = pattern.exec(searchValue)) !== null) {
    const keyword = match[1];
    const rawValue = match[2];
    if (keyword && rawValue !== undefined) {
      const value = rawValue.replace(/\*$/, '').replace(/^"=/, '"');
      const field = searchFields.find(
        f => getLocalizedKeyword(f, locale).toLowerCase() === keyword.toLowerCase(),
      );
      if (field) {
        chips.push({ field, value });
        continue;
      }
    }
    // Plain text token (unrecognized field prefix or bare word/phrase)
    chips.push({ field: null, value: match[0] });
  }
  return chips;
};
